import styled, { css } from 'styled-components';
import { media } from 'src/components/base';
import { TabAnchor } from './types';

// Desktop height of no reviews and title
const MIN_HEIGHT_DESKTOP_REVIEWS = '400px';

// Desktop height of price history with top padding, but no ads
const MIN_HEIGHT_DESKTOP_STATISTICS = '625px';

export const SectionWrapper = styled.div<{ id: TabAnchor }>(
  props => css`
    ${props.id === TabAnchor.REVIEWS &&
    css`
      min-height: ${MIN_HEIGHT_DESKTOP_REVIEWS};
    `}

    ${props.id === TabAnchor.STATISTICS &&
    css`
      min-height: 343.094px;

      ${media.mediumUp`
        min-height: ${MIN_HEIGHT_DESKTOP_STATISTICS};
      `}
    `}
  `
);
